import {
  WorkOrderServiceCategory,
  type WorkOrderServiceItem,
} from '@backoffice-frontend/graphql'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { workOrderServiceCategoryOf } from '../../utils/WorkOrderServiceItemCategories'
import type { WorkOrderAssigneeOption } from './WorkOrderAssigneeField'

const OPSCARE_RIGHTS_BY_CATEGORY: Record<
  WorkOrderServiceCategory,
  BoumRight[]
> = {
  [WorkOrderServiceCategory.HubActivities]: [
    BoumRight.APP_OPSCARE_HUB_ACTIVITIES,
  ],
  [WorkOrderServiceCategory.Incident]: [BoumRight.APP_OPSCARE_IN_FIELD_SUPPORT],
  [WorkOrderServiceCategory.MaintenanceService]: [
    BoumRight.APP_OPSCARE_MAINTENANCE_SERVICE,
  ],
  [WorkOrderServiceCategory.DamagesDefects]: [
    BoumRight.APP_OPSCARE_DAMAGES_DEFECTS,
  ],
  [WorkOrderServiceCategory.Other]: [],
  [WorkOrderServiceCategory.Ivc]: [],
}

export const opsCareCategoryRights = (
  serviceItem: WorkOrderServiceItem | '' | null | undefined,
): string[] => {
  const category = serviceItem ? workOrderServiceCategoryOf(serviceItem) : null
  const categoryRights = category ? OPSCARE_RIGHTS_BY_CATEGORY[category] : []

  return categoryRights.map(right => right.str())
}

type BackofficeUserIdentity = {
  id: string
  firstName: string
  lastName: string
}

export const assigneeName = ({
  firstName,
  lastName,
}: Pick<BackofficeUserIdentity, 'firstName' | 'lastName'>) =>
  `${firstName} ${lastName}`.trim()

/**
 * Maps backoffice users to assignee options, filtered by the combobox query
 * text. `backofficeUsers` accepts no arguments, so filtering has to happen
 * client-side.
 */
export const toAssigneeOptions = (
  users: BackofficeUserIdentity[] | null | undefined,
  query: string,
): WorkOrderAssigneeOption[] => {
  const normalisedQuery = query.trim().toLowerCase()

  return (users ?? [])
    .map(user => ({ id: user.id, name: assigneeName(user) }))
    .filter(option => option.name.toLowerCase().includes(normalisedQuery))
    .sort((a, b) => a.name.localeCompare(b.name))
}
